import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import CheckEmailPage from '@/pages/check-email'

const searchSchema = z.object({
  email: z.string().email().optional(),
  redirect: z.string().startsWith('/').max(2048).optional(),
})

export const Route = createFileRoute('/$lang/check-email')({
  validateSearch: (search) => searchSchema.parse(search),
  component: CheckEmailPage,
  staticData: { layout: 'public' },
})
